import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import IPage from 'models/Page';
import { PageEditFormProps } from '../pageEditRegistry';
import WaitingForm from 'pages/OwnerPage/QuizFormPage/TabContentPages/Waiting/WaitingForm';

const WaitingPageForm: FC<PageEditFormProps> = ({ pageRef, quizId }) => {
  const { watch } = useFormContext();
  const pages: IPage[] = watch('pages') || [];
  const page = pages.find((p: IPage) => p.uuid === pageRef);
  const waitingRef = page?.refs?.[0];

  if (!waitingRef || !quizId) return null;

  return <WaitingForm waitingRef={waitingRef} quizId={quizId} />;
};

export default WaitingPageForm;
